<template>
  <div
    class="flex flex-col gap-3 rounded-[20px] bg-[#f8f7f3] p-7"
    aria-hidden="true"
  >
    <div class="h-5 w-1/3 animate-pulse rounded bg-black-05" />
    <div class="h-4 w-full animate-pulse rounded bg-black-05" />
    <div class="h-4 w-5/6 animate-pulse rounded bg-black-05" />
    <div class="h-4 w-2/3 animate-pulse rounded bg-black-05" />
  </div>
</template>
